
import HttpClienteToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { HttpResponse } from '../../interfaces/auth/AuthInterface';
import { AgregarCalendarioParams, CalendarioProps } from '../../interfaces/admin/CalendarioInterface';

export const Calendario = () => {

    return new Promise<CalendarioProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Calendario/', token)
            .then( ({ data } : { data : CalendarioProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const AgregarCalendario = ( params: AgregarCalendarioParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Calendario/AgregarCalendario', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {               
                resolve( data );                
            })
            .catch( ( error : AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}